<template>
  <div class="activityList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>胸卡列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="operas">
      <div class="tktNum">
        <span>可申请证件数量：<b style="color:red;">{{ticketNumObj.totalTicketNum}}</b>张，</span>
        <span>已提交证件数量：<b style="color:green;">{{ticketNumObj.submittedTicketNum}}</b>张</span>
      </div>
      <div>
        <el-button class="filter-item" @click="showImportExcel=true" style="margin-left: 10px;" type="primary">批量导入</el-button>
        <el-button type="primary" @click="addCard" :style="buttonStyle">新增</el-button>
      </div>
    </div>

    <!-- <div style="font-size:14px;margin-top:-30px;width:80%">请前往展会现场扫码登录后，凭领证码自助领取胸卡，如遇任何问题请咨询现场报道服务台。</div> -->

    <div style="display:flex">
      <div style="text-align:center;width:200px;">
        <div style="font-size:16px; padding-top:20px;padding-bottom:10px">扫码注册</div>
        <div>
          <div id="PsnQRCode" style="margin:auto;width:160px"></div>
          <div>  <p @click="downs('PsnQRCode')"><span style="border:1px solid #333; border-radius: 3px; cursor: pointer;display:inline-block; padding: 6px 12px; font-size:12px;margin-top:20px">下载二维码</span></p></div>
        </div>
      </div>
      <div style="font-size:14px;padding-top:50px">可截图或下载二维码分享给同事，使用微信扫码，免登录提交证件信息。</div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="tktName"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="tktComName"
        label="公司名">
      </el-table-column>
      <!-- <el-table-column
        label="头像"
        width="160">
        <template slot-scope="scope">
          <img style="max-height:100px;" :src="scope.row.photo"/>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="tktPassportNo"
        label="证件号">
      </el-table-column>
      <el-table-column
        prop="tktRank"
        label="职位">
      </el-table-column>
      <el-table-column
        label="操作"
        width="160"
      
        >
        <template slot-scope="scope"   v-if="scope.row.tktIfMakeCard !='1'">
          <el-button @click="editCard(scope.row)" type="text" size="small">修改</el-button>
          <el-button @click="deletCard(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 批量导入 -->
    <el-dialog title="批量导入" :visible.sync="showImportExcel" width="30%" center>
      <BatchImport class="filter-item" v-on:drToggle="drToggleChange" :demoExcel="demoExcel" :needAtrID="false" :upApi="importApi"/>
    </el-dialog>

  </div>
</template>
<script>
import api from '@/api'
import reg from '@/utils/regExp'
import tools from '../../utils/tools.js';
import BatchImport from '@/components/BatchImport'
import QRCode from 'qrcodejs2'
export default {
  name: 'card',
  components: { BatchImport },
  data() {
    return {
      tableData: [],
      ticketNumObj: {},
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      showImportExcel:false,
      demoExcel: './ExcelDemo.xlsx', // 导入模板
      importApi: `${api.batchactorimport()}?ExhID=${localStorage.getItem('ExhID')}`,// 批量展商接口
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
    }
  },
  mounted() {
    this.getTicket()
    this.getticketnum()
    console.log(localStorage.getItem('ExhID'))
    var that =this
    var textStr = ''
    if(localStorage.getItem('ExhID') == '9669'){
      textStr = `https://ticket.exporeg.cn/web/2024/CN/24hslfAt/#/login?ExhID=${localStorage.getItem('ExhID')}&atrCode=${that.userInfo.atrCode}`
    }
    if(localStorage.getItem('ExhID') == '9668'){
      textStr = `https://ticket.exporeg.cn/web/2024/CN/24hssjAt/#/login?ExhID=${localStorage.getItem('ExhID')}&atrCode=${that.userInfo.atrCode}`
    }
    document.getElementById('PsnQRCode').innerHTML = ''
    // console.log(textStr,'xxxxxxxxxxxxxxxxxx')
    // 生成卡号二维码
    let PsnQRCode = new QRCode('PsnQRCode', {
      // eslint-disable-line
      width: 160,
      height: 160, // 高度
      colorDark: 'black', // 二维码颜色
      colorLight: '#ffffff', // 二维码背景色
      text: textStr // 二维码内容（只存储的卡号）
    })

  },
  methods: {
    downs(str) {
      var that = this
      // //找到canvas标签
      let myCanvas = document.getElementById(str).getElementsByTagName('canvas')
      let img = document.getElementById(str).getElementsByTagName('img')
      // // //创建一个a标签节点
      let a = document.createElement('a')
      // //设置a标签的href属性（将canvas变成png图片）
      let imgURL = myCanvas[0].toDataURL('image/jpg')
      let ua = navigator.userAgent
      if (ua.indexOf('Trident') != -1 && ua.indexOf('Windows') != -1) {
        // IE内核 并且  windows系统 情况下 才执行;
        var bstr = atob(imgURL.split(',')[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        var blob = new Blob([u8arr])
        window.navigator.msSaveOrOpenBlob(blob, '下载' + '.' + 'png')
      } else if (ua.indexOf('Firefox') > -1) {
        //火狐兼容下载
        let blob = this.base64ToBlob(imgURL) //new Blob([content]);
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', true, true) //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        a.download = ' ' //下载图片名称，如果填内容识别不到，下载为未知文件，所以我这里就不填为空
        a.href = URL.createObjectURL(blob)
        a.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })) //兼容火狐
      } else {
        //谷歌兼容下载
        img.src = myCanvas[0].toDataURL('image/jpg')
        // a.href = myCanvas[0].toDataURL('image/png').replace('image/png', 'image/octet-stream')
        a.href = img.src
        //设置下载文件的名字
        a.download = '2024参展商证件注册'
        //点击
        a.click()
      }
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], { type: contentType })
    },

    drToggleChange(data) {
      this.showImportExcel = data
      this.getTicket()
      this.getticketnum()
    },
    getticketnum() {
      api.getticketnum().then(res => {
        if (res.data.code === 200) {
          this.ticketNumObj = res.data.data
          this.overlayshow = false
        }
      })
    },
    addCard() {
      if (this.ticketNumObj.totalTicketNum > this.ticketNumObj.submittedTicketNum) {
        this.$router.push({path: '/addCard', query: {type: 'add'}})
      } else {
        this.$notify({
          title: '错误',
          message: '证件数量已达上限',
          type: 'error'
        });
      }
    },
    deletCard(row) {
      this.$confirm('确定删除该证件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        api.deleteticket({tktID: ''+row.tktID}).then(res => {
          if (res.data.code === 200) {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            this.getTicket()
            this.getticketnum()
          }
        })
      }).catch(() => {});
    },
    resetForm() {
      this.ruleForm={
        tktName: '',
        tktComName: '',
        photo: '',
        tktIDCard: '',
        tktRank: ''
      }
    },
    getTicket() {
      api.ticketlist().then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data
        }
      })
    },
    editCard(row, type) {
      this.$router.push({path: '/addCard', query: {type: 'edit', tktID: row.tktID}})
    }
  }
}
</script>

<style lang="less" scoped>
.activityList{
  .tktNum{
    span{
      font-size: 14px;
      b{
        font-size: 16px;
        padding: 0 10px;
      }
    }
  }
  .operas{
    text-align: right;
    padding: 20px 0;
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  .fileParent {
    position: relative;
    img {
      position: absolute;
      width: 60px;
      height: 39px;
      left: 0;
      top: 0;
    }
  }
  .file {
    position: absolute;
    left: 0;
    opacity: 0;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:120px;
        height: auto;
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px;
      }
    }
  }
}
</style>
